(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) =>
      `<span class="bb-flavour-chip">${f}</span>${i < reordered.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
    ).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips} <a href="/pages/build-your-box" class="bb-build-link">– Customise →</a>`;
  }

  // Raspberry
  window.adConfigs['retargeting-nudge-raspberry'] = {
    subline1: 'Go on',
    subline2: buildFlavourChips('Raspberry'),
    cartSub:  buildFlavourList('Raspberry'),
    image:    null,
  };

  // Caramel
  window.adConfigs['retargeting-nudge-caramel'] = {
    subline1: 'Treat yourself',
    subline2: buildFlavourChips('Caramel'),
    cartSub:  buildFlavourList('Caramel'),
    image:    null,
  };

  // Mixed Box
  const mixedChips = flavours.map((f, i) =>
    `<span class="bb-flavour-chip">${f}</span>${i < flavours.length - 1 ? ' <span class="bb-sep">·</span> ' : ''}`
  ).join('');

  window.adConfigs['retargeting-nudge-mixedbox'] = {
    subline1: "This one's still here",
    subline2: `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${mixedChips}`,
    cartSub:  'Six bars: ' + flavours.join(' · '),
    image:    null,
  };

})();